import { Badge, BadgeProps } from '@mui/material';
import { styled } from '@mui/system';

export type StyledCounterProps = BadgeProps & {
  /** Whether to show the counter */
  show?: boolean;
};

/**
 * @description StyledCounter is a component that should wrap another component and
 * will add a badge to it showing a count.
 */
export const StyledCounter = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'show',
})<StyledCounterProps>(({ show = true }) => ({
  '& .MuiBadge-badge': {
    right: 6,
    top: 6,
    fontSize: 10,
    height: 16,
    width: 16,
    minWidth: 16,
    textAlign: 'center',
    padding: 0,
    pointerEvents: 'none',
    display: 'inline-block',
    transform: 'translate(80%, -80%)',
    // this is to make it easier to wrap an element with this component
    // and conditionally show/hide it
    ...(!show && {
      display: 'none',
    }),
  },
}));
